import { Grid, Paper, Table, TableBody, TableHead, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import React from "react";
import { useSelector } from "react-redux";
import { selectRequestDocs } from "redux/modules/statusReportSlice";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#f1f3f9",
        color: "#172b4d",
        fontSize: 16,
    },
    body: {
        fontSize: 16,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.main,
        },
    },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.common.white,
        padding: "18px 48px",
    },
    title: {
        color: theme.palette.darkIndigo.main,
    },
    subTitle: {
        "& a": {
            color: theme.palette.secondary.main,
        },
    },
    flexRow: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    },
    circle: {
        width: 25,
        height: 25,
        borderRadius: 25,
        backgroundColor: theme.palette.error.main,
    },
    triangle: {
        margint: 0,
        padding: 0,
        fontSize: 30,
        color: theme.palette.success.main,
    },
    table: {
        minWidth: 700,
        "& .MuiTableCell-root": {
            borderLeft: "1px solid rgba(224, 224, 224, 1)",
        },
    },
    badge: {
        display: "flex",
        width: 25,
        height: 25,
        borderRadius: 25,
        backgroundColor: "#feb969",
        marginRight: 8,
        textAlign: "center",
        color: "#fff",
        justifyContent: "center",
        alignItems: "center",
    },
    wrapTitleContent: {
        width: 78,
        display: "flex",
        justifyContent: "center",
    },
    tableTitle: {
        color: "#172b4d",
        marginLeft: 18,
    },
}));

const DocumentStatus = ({ status }) => {
    const classes = useStyles();

    if (status === "mandatory") {
        return (
            <div className={classes.flexRow}>
                <div className={classes.circle}></div>
            </div>
        );
    } else if (status === "applicable") {
        return <span className={classes.triangle}>▲</span>;
    }

    return null;
};

export default function StatusReportRequestForm({
    onCancel = () => { },
    onSubmit = () => { },
}) {
    const classes = useStyles();
    const { docRequests } = useSelector((state) => state.statusReport);

    const reqDocs = useSelector(selectRequestDocs);

    return (
        <div className={classes.root}>
            <Typography variant="h6" className={classes.title}>
                Smart Visa Status Report Request Form
            </Typography>
            <Typography variant="h4" color="secondary">
                Documents Required  for Status Report Request Form
            </Typography>

            <Grid
                container
                style={{ marginTop: 30, display: "flex", alignItems: "center", justifyContent: "flex-end" }}
            >
                <Grid item className={classes.flexRow}>
                    <div className={classes.circle}></div>
                    <Typography style={{ marginLeft: 10, marginRight: 10 }}>
                        Mandatory
                    </Typography>
                </Grid>
                <Grid item className={classes.flexRow}>
                    <span className={classes.triangle}>▲</span>
                    <Typography style={{ marginLeft: 10 }}>If applicable</Typography>
                </Grid>
            </Grid>

            <TableContainer
                style={{ marginTop: 12, borderRadius: 4 }}
                component={Paper}
            >
                {
                    Object.entries(reqDocs).map(([key, value]) => (
                        <Table key={key} className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>
                                        <Typography variant="h6" className={classes.tableTitle}>
                                            {key}
                                        </Typography>
                                    </StyledTableCell>
                                    <StyledTableCell align="center" width={80}></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {
                                    value.map((row, index) => (
                                        <StyledTableRow key={row.configDocumentRequiredID}>
                                            <StyledTableCell component="th" scope="row">
                                                <div style={{ display: "flex" }}>
                                                    <div className={classes.wrapTitleContent}>
                                                        <div className={classes.badge}>
                                                            {index + 1}
                                                        </div>
                                                    </div>
                                                    <div style={{ display: "flex", flex: 1 }}>
                                                        <Typography>
                                                            {row.documentName}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {
                                                    row.isRequired &&
                                                    <div className={classes.flexRow}>
                                                        <div className={classes.circle}></div>
                                                    </div>
                                                }
                                                {
                                                    !row.isRequired &&
                                                    <span className={classes.triangle}>▲</span>
                                                }
                                            </StyledTableCell>

                                        </StyledTableRow>

                                    ))
                                }

                            </TableBody>
                        </Table>
                    ))

                }
            </TableContainer>

            <br />
            <br />
            <div className={classes.flexRow}>
                <ColorButton
                    variant="outlined"
                    color="secondary"
                    style={{ width: 120 }}
                    onClick={onCancel}
                >
                    BACK
                </ColorButton>
                <ColorButton
                    variant="contained"
                    color="primary"
                    style={{ width: 120, marginLeft: 20 }}
                    onClick={onSubmit}
                >
                    SUBMIT
                </ColorButton>
            </div>
            <br />
            <br />
        </div>
    );
}
